import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { actions } from 'features/reports/redux';
import { actions as usersActions } from 'features/users/redux';

const banks = [
  { value: 'CBU', name: 'CBU' },
  { value: 'Alias', name: 'Alias' },
  { value: 'Número de cuenta', name: 'Número de cuenta' },
  { value: 'Pix', name: 'Pix' },
  { value: 'Plin', name: 'Plin' },
  { value: 'Yape', name: 'Yape' },
];

const initialValues = {
  titular: '',
  activeBankSelector: { value: 'CBU', name: 'CBU' },
  details: '',
  openedItemId: null,
  addRequisites: false,
};

const initialSettingLimitsValues = {
  minimumDeposit: '',
  minimumWithdrawal: '',
};

const useCBU = () => {
  const actionProcessing = useSelector(s => s.reports.actionProcessing);
  const currentRequisites = useSelector(s => s.users.profile);
  const settingLimits = useSelector(s => s.users.settingLimits);
  const { semiAutoWithdrawalEnabled } = useSelector(s => s.auth);

  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSettingModalOpen, setIsSettingModalOpen] = useState(false);

  const [values, setValues] = useState(() => ({
    ...initialValues,
  }));

  const [settingLimitsValues, setSettingLimitsValues] = useState(() => ({
    ...initialSettingLimitsValues,
  }));

  const handleValueChange = (name, value) => {
    setValues(ps => ({
      ...ps,
      [name]: value,
    }));
  };

  const handleSettingLimitsValueChange = (name, value) => {
    setSettingLimitsValues(ps => ({
      ...ps,
      [name]: value,
    }));
  };

  const handleCreateBank = e => {
    e.preventDefault();

    if (!actionProcessing) {
      dispatch(
        actions.createBank(
          { titular: values.titular, bank: values.activeBankSelector.value, details: values.details },
          () => {
            dispatch(usersActions.getProfileInfo());
            setIsModalOpen(false);
            setValues({ ...initialValues });
          },
        ),
      );
    }
  };

  const handleUpdateBank = e => {
    e.preventDefault();

    if (!actionProcessing) {
      dispatch(
        actions.updateBank(
          {
            titular: values.titular,
            bank: values.activeBankSelector.value,
            details: values.details,
            id: values.openedItemId,
          },
          () => {
            dispatch(usersActions.getProfileInfo());
            setIsModalOpen(false);
            setValues({ ...initialValues });
          },
        ),
      );
    }
  };

  const handleDeleteBank = e => {
    e.preventDefault();

    if (!actionProcessing) {
      dispatch(
        actions.deleteBank(
          {
            id: values.openedItemId,
          },
          () => {
            dispatch(usersActions.getProfileInfo());
            setIsModalOpen(false);
            handleValueChange('openedItemId', null);
          },
        ),
      );
    }
  };

  const handleSelectBank = itemValue => {
    setValues(ps => ({
      ...ps,
      activeBankSelector: { value: itemValue, name: itemValue },
    }));
  };

  const handleAddRequisites = itemValue => {
    setValues(ps => ({
      /* ...ps, */
      ...initialValues,
      addRequisites: itemValue,
      openedItemId: null,
    }));
  };

  const handleSetSettingLimits = e => {
    e.preventDefault();

    dispatch(
      usersActions.setSettingLimits(
        {
          minimumDeposit: settingLimitsValues.minimumDeposit,
          minimumWithdrawal: settingLimitsValues.minimumWithdrawal,
        },
        () => setIsSettingModalOpen(false),
      ),
    );
  };

  const toggleItem = id => {
    setValues(ps => ({
      ...ps,
      openedItemId: ps.openedItemId === id ? null : id,
      addRequisites: false,
    }));
  };

  useEffect(() => {
    const filteredItem = currentRequisites.filter(requisite => requisite.id === values.openedItemId)[0];

    values.openedItemId &&
      setValues(ps => ({
        ...ps,
        titular: filteredItem.titular,
        details: filteredItem.details,
        activeBankSelector: { value: filteredItem.bank, name: filteredItem.bank },
      }));
  }, [values.openedItemId, currentRequisites]);

  useEffect(() => {
    setSettingLimitsValues(ps => ({
      ...ps,
      minimumDeposit: settingLimits.minimumDeposit === 0 ? '' : settingLimits.minimumDeposit,
      minimumWithdrawal: settingLimits.minimumWithdrawal === 0 ? '' : settingLimits.minimumWithdrawal,
    }));
  }, [settingLimits]);

  useEffect(() => {
    if (semiAutoWithdrawalEnabled) {
      dispatch(usersActions.getSettingLimitsInfo());
      dispatch(usersActions.getProfileInfo());
    }
  }, [semiAutoWithdrawalEnabled]);

  return {
    state: {
      values,
      settingLimitsValues,
      isModalOpen,
      isSettingModalOpen,
      currentRequisites,
    },
    handlers: {
      setIsModalOpen,
      setIsSettingModalOpen,
      handleValueChange,
      handleSettingLimitsValueChange,
      handleCreateBank,
      handleSelectBank,
      toggleItem,
      handleAddRequisites,
      handleUpdateBank,
      handleDeleteBank,
      handleSetSettingLimits,
    },
    out: {
      banks,
    },
  };
};

export default useCBU;
